import roleTypes from "../types/role";

function inviteDetails(payload) {
  return {
    type: roleTypes.INVITE_DETAILS,
    payload,
  };
}
function inviteDetailsSuccess(payload) {
  return {
    type: roleTypes.INVITE_DETAILS_SUCCESS,
    payload,
  };
}

function inviteDetailsFailure(payload) {
  return {
    type: roleTypes.INVITE_DETAILS_FAILURE,
    payload,
  };
}

function downloadCR(payload) {
  return {
    type: roleTypes.DOWNLOAD_CR,
    payload,
  };
}
function downloadCRSuccess(payload) {
  return {
    type: roleTypes.DOWNLOAD_CR_SUCCESS,
    payload,
  };
}

function downloadReportStatus(payload) {
  return {
    type: roleTypes.DOWNLOAD_REPORT_STATUS,
  };
}

function CandidateProfile(payload) {
  return {
    type: roleTypes.CANDIDATE_PROFILE,
    payload,
  };
}
function CandidateProfileSuccess(payload) {
  return {
    type: roleTypes.CANDIDATE_PROFILE_SUCCESS,
    payload,
  };
}
function CandidateProfileFailure(payload) {
  return {
    type: roleTypes.CANDIDATE_PROFILE_FAILURE,
    payload,
  };
}

function CandidateJobSpecificProfile(payload) {
  return {
    type: roleTypes.CANDIDATE_JOB_SPECIFIC_PROFILE,
    payload,
  };
}
function CandidateJobSpecificProfileSuccess(payload) {
  return {
    type: roleTypes.CANDIDATE_JOB_SPECIFIC_PROFILE_SUCCESS,
    payload,
  };
}
function CandidateJobSpecificProfileFailure(payload) {
  return {
    type: roleTypes.CANDIDATE_JOB_SPECIFIC_PROFILE_FAILURE,
    payload,
  };
}

function updateTimelineEvents(payload) {
  return {
    type: roleTypes.UPDATE_TIMELINE_EVENTS,
    payload,
  };
}
function updateTimelineEventsSuccess(payload) {
  return {
    type: roleTypes.UPDATE_TIMELINE_EVENTS_SUCCESS,
    payload,
  };
}
function updateTimelineEventsFailure(payload) {
  return {
    type: roleTypes.UPDATE_TIMELINE_EVENTS_FAILURE,
    payload,
  };
}

function clearUpdateTimelineEvents() {
  return {
    type: roleTypes.CLEAR_UPDATE_TIMELINE_EVENTS,
  };
}

function candidateProfileReport(payload) {
  return {
    type: roleTypes.CANDIDATE_PROFILE_REPORT,
    payload,
  };
}
function candidateProfileReportSuccess(payload) {
  return {
    type: roleTypes.CANDIDATE_PROFILE_REPORT_SUCCESS,
    payload,
  };
}
function candidateProfileReportFailure(payload) {
  return {
    type: roleTypes.CANDIDATE_PROFILE_REPORT_FAILURE,
    payload,
  };
}
function profileMatchReport(payload) {
  return {
    type: roleTypes.PROFILE_MATCH_REPORT,
    payload,
  };
}
function profileMatchReportSuccess(payload) {
  return {
    type: roleTypes.PROFILE_MATCH_REPORT_SUCCESS,
    payload,
  };
}
function profileMatchReportFailure(payload) {
  return {
    type: roleTypes.PROFILE_MATCH_REPORT_FAILURE,
    payload,
  };
}

function getQuesAnsByTrackingId(payload) {
  return {
    type: roleTypes.GET_QUES_ANS_BY_TRACKING_ID,
    payload,
  };
}
function getQuesAnsByTrackingIdSuccess(payload) {
  return {
    type: roleTypes.GET_QUES_ANS_BY_TRACKING_ID_SUCCESS,
    payload,
  };
}
function getQuesAnsByTrackingIdFailure(payload) {
  return {
    type: roleTypes.GET_QUES_ANS_BY_TRACKING_ID_FAILURE,
    payload,
  };
}

function codingSubmissionDetails(payload) {
  return {
    type: roleTypes.CODING_SUBMISSION_DETAILS,
    payload,
  };
}
function codingSubmissionDetailsSuccess(payload) {
  return {
    type: roleTypes.CODING_SUBMISSION_DETAILS_SUCCESS,
    payload,
  };
}
function codingSubmissionDetailsFailure(payload) {
  return {
    type: roleTypes.CODING_SUBMISSION_DETAILS_FAILURE,
    payload,
  };
}

function getBehaviorSkills(payload) {
  return {
    type: roleTypes.GET_BEHAVIOR_SKILLS,
    payload,
  };
}
function getBehaviorSkillsSuccess(payload) {
  return {
    type: roleTypes.GET_BEHAVIOR_SKILLS_SUCCESS,
    payload,
  };
}
function getBehaviorSkillsFailure(payload) {
  return {
    type: roleTypes.GET_BEHAVIOR_SKILLS_FAILURE,
    payload,
  };
}

export default {
  inviteDetails,
  inviteDetailsSuccess,
  inviteDetailsFailure,
  downloadCR,
  downloadCRSuccess,
  downloadReportStatus,
  CandidateProfile,
  CandidateProfileSuccess,
  CandidateProfileFailure,
  CandidateJobSpecificProfile,
  CandidateJobSpecificProfileSuccess,
  CandidateJobSpecificProfileFailure,
  updateTimelineEvents,
  updateTimelineEventsSuccess,
  updateTimelineEventsFailure,
  clearUpdateTimelineEvents,
  candidateProfileReport,
  candidateProfileReportSuccess,
  candidateProfileReportFailure,
  profileMatchReport,
  profileMatchReportSuccess,
  profileMatchReportFailure,
  getQuesAnsByTrackingId,
  getQuesAnsByTrackingIdSuccess,
  getQuesAnsByTrackingIdFailure,
  codingSubmissionDetails,
  codingSubmissionDetailsSuccess,
  codingSubmissionDetailsFailure,
  getBehaviorSkills,
  getBehaviorSkillsSuccess,
  getBehaviorSkillsFailure,
};
